import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import Services from "@/components/site/Services";
import Stats from "@/components/site/Stats";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <main className="relative bg-[#050B14] text-[#F8FAFC]" data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Manifesto />
      <Services />
      <Stats />
      <Contact />
      <Footer />
    </main>
  );
}
